// Footer.jsx

import { Box, Typography } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

import { footerHeight } from "components/PageLayout";

interface FooterProps {
  copyright?: boolean;
}

const Footer: React.FC<FooterProps> = ({ copyright }) => {
  const intl = useIntl();

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        height: footerHeight,
        borderTop: "1px solid",
        borderTopColor: "divider",
        bgcolor: "footercolor.main",
        color: "footercolor.contrastText",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
      }}
    >
      {copyright && (
        <Typography variant="body2" component="div">
          {intl.formatMessage({ id: "copyright_id" })}
        </Typography>
      )}
    </Box>
  );
};

export default Footer;
